export enum EmailSettingsStatus {
    Disabled = 0,
    Enabled = 1,
    ConnectFail = 2,
    AuthFail = 3,
    ReadFail = 4,
    ReadSuccess = 5,
}
